"use strict";var findIndex = require('core-js-pure/features/array/find-index');

module.exports = {
  handleChange(event) {
    var selectedIndex = event.target.selectedIndex;
    var el = this.getEls('option')[selectedIndex];
    var option = this.input.options[selectedIndex];

    this.state.selectedIndex = selectedIndex;

    // TODO: we should not cast the selected value to a string here, but this is a breaking change.
    this.emit('change', {
      index: selectedIndex,
      selected: [String(option.value)],
      el });

  },

  onCreate() {
    this.state = { selectedIndex: 0 };
  },

  onInput(input) {
    var state = this.state;
    input.options = input.options || [];
    state.selectedIndex = Math.max(
    0,
    findIndex(input.options, function (option) {return option.selected;}));

  } };